const feedType = {
  WORKOUT_COMPLETE: 'WORKOUT_COMPLETE',
  CUSTOM_WORKOUT: 'CUSTOM_WORKOUT',
  NEED_NEW_WORKOUTS: 'NEED_NEW_WORKOUTS',
  TRACKED_ACTIVITY: 'TRACKED_ACTIVITY',
  DAILY_SUMMARY: 'DAILY_SUMMARY',
  ARCHIVED: 'ARCHIVED',
  CHECK_IN: 'CHECK_IN',
  CLIENT_STATUS: 'CLIENT_STATUS',
  SPECIAL: 'SPECIAL',
  PAUSE_REQUEST: 'PAUSE_REQUEST',
  WORKOUT_FEEDBACK_REQUEST: 'WORKOUT_FEEDBACK_REQUEST',
  NEED_NEW_MEAL_PLAN: 'NEED_NEW_MEAL_PLAN',
  ASSIGN_TRACK: 'ASSIGN_TRACK',
  DISENGAGED_CLIENT: 'DISENGAGED_CLIENT',
  COACH_TASK: 'COACH_TASK',
  TODO: 'TODO',
  USER_PREFERENCE_CHANGE: 'USER_PREFERENCE_CHANGE',
  WORKOUT_CONFLICT_REVIEW: 'WORKOUT_CONFLICT_REVIEW',
};

// NOTE: Feed ordering is temporarily disabled with S2-3357 except for
// check-ins and workout feedback requests only.
// Feed activity types related to the work item re-ordering
const feedOrderingActivityTypes = [
  feedType.CHECK_IN,
  // feedType.NEED_NEW_MEAL_PLAN,
  // feedType.NEED_NEW_WORKOUTS,
  feedType.WORKOUT_FEEDBACK_REQUEST,
];

const mainFeedTypes = [
  feedType.CHECK_IN,
  feedType.NEED_NEW_WORKOUTS,
  feedType.NEED_NEW_MEAL_PLAN,
  feedType.WORKOUT_FEEDBACK_REQUEST,
  feedType.CLIENT_STATUS,
  feedType.DAILY_SUMMARY,
  feedType.SPECIAL,
  feedType.PAUSE_REQUEST,
  feedType.DISENGAGED_CLIENT,
  feedType.COACH_TASK,
  feedType.TODO,
  feedType.USER_PREFERENCE_CHANGE,
  feedType.WORKOUT_CONFLICT_REVIEW,
];

const footerFeedTypes = [
  feedType.ARCHIVED,
];

const nonActivityFeedTypes = [
  feedType.TODO,
];

const coachActivityFeedTypes = mainFeedTypes.filter((type) => !nonActivityFeedTypes.includes(type));

export default feedType;

export {
  mainFeedTypes,
  footerFeedTypes,
  coachActivityFeedTypes,
  feedOrderingActivityTypes,
};
